import { getCookie } from "@/modules/client/getCookies"
import { I18N_DEBUG_COOKIE_NAME } from "@/modules/featureEnv/constants"

export const isI18nDebugMode = (): boolean => {
  // Debug mode is activated if value is "1"
  const value = getCookie(I18N_DEBUG_COOKIE_NAME)
  return value === "1"
}
